const pendingSelfLeaves = new Set<string>();
const pendingInviteDeclines = new Set<string>();

const dissolvingSquads = new Map<string, number>();
const DISSOLVING_TTL_MS = 5_000;

function pruneDissolvingSquads(): void {
  const now = Date.now();
  for (const [squadId, expiresAt] of dissolvingSquads) {
    if (expiresAt <= now) dissolvingSquads.delete(squadId);
  }
}

export function markPendingSelfLeave(squadId: string): void {
  pendingSelfLeaves.add(squadId);
}

export function clearPendingSelfLeave(squadId: string): void {
  pendingSelfLeaves.delete(squadId);
}

export function isPendingSelfLeave(squadId: string): boolean {
  return pendingSelfLeaves.has(squadId);
}

/** Squad dissolve in progress (squads DELETE received). Auto-expires after ~5s. */
export function markDissolvingSquad(squadId: string): void {
  pruneDissolvingSquads();
  dissolvingSquads.set(squadId, Date.now() + DISSOLVING_TTL_MS);
}

export function isDissolvingSquad(squadId: string): boolean {
  pruneDissolvingSquads();
  return dissolvingSquads.has(squadId);
}

/** User declined a squad re-invite; skip kick handling on squad_members DELETE. */
export function markPendingInviteDecline(squadId: string): void {
  pendingInviteDeclines.add(squadId);
}

export function clearPendingInviteDecline(squadId: string): void {
  pendingInviteDeclines.delete(squadId);
}

export function isPendingInviteDecline(squadId: string): boolean {
  return pendingInviteDeclines.has(squadId);
}
